// extracted by mini-css-extract-plugin
module.exports = {"date":"styles_date__1TWNe","description":"styles_description__2GLm_"};